import { Text, Flex, Image, Icon, Button } from '@chakra-ui/react';
import logofooter from '../../src/assets/img/components/logofooter.svg';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const socialLinks = [
  { icon: FaFacebookF, url: 'https://www.facebook.com/profile.php?id=61575770355946&locale=es_LA' },
  { icon: FaInstagram, url: 'https://www.instagram.com/tmg__international/' },
  { icon: FaLinkedinIn, url: 'https://www.linkedin.com/company/tmg-international-llc/posts/?feedView=all' },
];

function Footer() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Flex
      id="footer"
      bg="#1E1D1D"
      width="100%"
      direction="column"
      py="2%"
      fontSize="100%"
    >
      <Flex
        width={{ base: '100%', md: '93%' }}
        align="center"
        justify="space-between"
        px={{ base: '2%', md: '5%' }}
        flexDirection={{ base: 'column', md: 'row' }}
        marginTop={'3%'}
      >
        {/* Logo + Texto */}
        <Flex flexDirection="column"
          alignItems={{ base: 'center', md: 'flex-start' }}
          width={{ base: '60%', md: '17%' }}
          marginBottom={{ base: '3%', md: '1%' }}
        >
          <Image
            src={logofooter}
            width={{ base: '70%', md: '90%', lg: '40%' }}
            mt={{ base: '3%', md: '0' }}
            mb={{ base: '3%', md: '11%' }}
          />
          <Text
            color="#9A9999"
            fontFamily="Inter"
            mt="5%"
            mb="3%"
            width={{ base: '100%', md: '100%', lg: '80%' }}
            textAlign={{ base: 'center', md: 'left' }}
          >
            {t("footer-info")}
          </Text>
        </Flex>

        {/* Navegación Interna */}
        <Flex flexDirection="column"
          gap={1}
          textAlign={{ base: 'center', md: 'center' }}
          fontFamily={'Inter'}
          marginBottom={{ base: '3%', md: '1%' }}
        >
          <Link to="/" style={{ color: "#9A9999" }}> {t("nav-item-1")}</Link>
          <Link to="/about-us" style={{ color: "#9A9999" }}> {t("nav-item-2")}</Link>
          <Link to="/services" style={{ color: "#9A9999" }}> {t("nav-item-3")}</Link>
          <Link to="/contact" style={{ color: "#9A9999" }}> {t("nav-item-4")}</Link>
        </Flex>

        {/* Redes + Botón */}
        <Flex flexDirection="column"
          marginBottom={{ base: '3%', md: '1%' }}
        >
          <Flex
            fontSize="250%"
            gap={{ base: '2%', md: '3%' }}
            align="center"
            mt="1%"
            mb="5%"
          >
            {socialLinks.map((item, idx) => (
              <a key={idx} href={item.url} target="_blank" rel="noopener noreferrer">
                <Icon
                  as={item.icon}
                  w="60%"
                  h="60%"
                  color="#9A9999"
                />
              </a>
            ))}
          </Flex>

          <Button
            type="button"
            onClick={() => navigate("/contact#quote-form")}
            width="100%"
            fontSize="120%"
            background="#ae8245"
            color="white"
            borderRadius="30px"
            fontFamily="Inter"
            fontWeight="medium"
            _hover={{ bg: '#d8973bff' }}
            padding={3}
          >
            {t("quote")}
          </Button>
        </Flex>
      </Flex>

      <Text
        textAlign="center"
        fontFamily="Avenir LT Pro"
        color="#9A9999"
        fontSize={{ base: '60%', md: '100%', lg: '120%' }}
        mt="2%"
      >
        © TMG, All rights reserved, 2026.
      </Text>
    </Flex>
  );
}

export default Footer;
